import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'redux-form';
import { Row, Col } from 'react-flexbox-grid';

import _get from 'lodash/get';

import { entityType, featuresType } from 'types';

import TrashTooltip from 'components/TrashTooltip';
import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';

import MarkOrFill from './components/MarkOrFill';
import Unmark from './components/Unmark';
import Shift from './components/Shift';

import { ACTION_TYPE } from '../../constants';

import './style.scss';

/* eslint-disable camelcase */

export default class Actions extends Component {
  static propTypes = {
    innerRef: PropTypes.func.isRequired,
    isArchived: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    allFeatures: PropTypes.arrayOf(featuresType),
    allEntities: PropTypes.arrayOf(entityType),

    // MATCHING-PATTERNS:
    matchingPatterns: PropTypes.arrayOf(entityType),
    matchingPatternsWithoutAnyAndW: PropTypes.arrayOf(entityType),

    onSearchEntity: PropTypes.func.isRequired,
    onCreateEntity: PropTypes.func.isRequired,
    onScrollBottom: PropTypes.func.isRequired,

    // REDUX-FORM:
    values: PropTypes.arrayOf(PropTypes.object),
    change: PropTypes.func.isRequired,
    untouch: PropTypes.func.isRequired,
  };

  createAddMarkHandler = fields => () => {
    fields.push({
      action_type: ACTION_TYPE.MARK,
    });

    this.props.onScrollBottom();
  };

  createAddUnmarkHandler = fields => () => {
    fields.push({
      action_type: ACTION_TYPE.UNMARK,
    });

    this.props.onScrollBottom();
  };

  createAddShiftHandler = fields => () => {
    fields.push({
      action_type: ACTION_TYPE.SHIFT,
    });

    this.props.onScrollBottom();
  };

  createAddFillHandler = fields => () => {
    fields.push({
      action_type: ACTION_TYPE.FILL,
    });

    this.props.onScrollBottom();
  };

  createDeleteHandler = (fields, index) => () => {
    fields.remove(index);
  };

  renderGroup = (fields, field, index) => {
    const {
      values,
      change,
      untouch,
      isArchived,
      isLoading,
      allEntities,
      allFeatures,
      onCreateEntity,
      onSearchEntity,
      matchingPatterns,
      matchingPatternsWithoutAnyAndW,
    } = this.props;

    const fieldPayload = fields.get(index);
    if (!fieldPayload) {
      return null;
    }

    const { action_type } = fieldPayload;
    const isEntityArchived = _get(
      fieldPayload[action_type],
      action_type === ACTION_TYPE.MARK
        ? 'entity.archived'
        : 'matching_pattern_element.archived',
      false,
    );

    return (
      <Row key={field} styleName="row">
        {/* <Col xs={3}>
          <div styleName="field-group-type">
            {FIELD_GROUP_TYPE_NAME[action_type]}
          </div>
        </Col> */}
        <Col xs={12} styleName="item">
          {action_type === ACTION_TYPE.MARK && (
            <MarkOrFill
              type={ACTION_TYPE.MARK}
              values={values[index]}
              field={field}
              change={change}
              untouch={untouch}
              allEntities={allEntities}
              isLoading={isLoading}
              allFeatures={allFeatures}
              matchingPatterns={matchingPatterns}
              matchingPatternsWithoutAnyAndW={matchingPatternsWithoutAnyAndW}
              onSearchEntity={onSearchEntity}
              onCreateEntity={onCreateEntity}
              isArchived={isArchived}
              isEntityArchived={isEntityArchived}
            />
          )}

          {action_type === ACTION_TYPE.UNMARK && (
            <Unmark
              field={field}
              matchingPatterns={matchingPatternsWithoutAnyAndW}
              isArchived={isArchived}
              isEntityArchived={isEntityArchived}
            />
          )}

          {action_type === ACTION_TYPE.SHIFT && (
            <Shift
              field={field}
              fieldPayload={fieldPayload}
              matchingPatterns={matchingPatterns}
              matchingPatternsWithoutAnyAndW={matchingPatternsWithoutAnyAndW}
              isArchived={isArchived}
              isEntityArchived={isEntityArchived}
            />
          )}

          {action_type === ACTION_TYPE.FILL && (
            <MarkOrFill
              type={ACTION_TYPE.FILL}
              field={field}
              change={change}
              untouch={untouch}
              allEntities={allEntities}
              allFeatures={allFeatures}
              matchingPatterns={matchingPatterns}
              matchingPatternsWithoutAnyAndW={matchingPatternsWithoutAnyAndW}
              onCreateEntity={onCreateEntity}
              isEntityArchived={isEntityArchived}
            />
          )}

          {!isArchived && (
            <TrashTooltip
              data-test="delete-action"
              styleName="trash"
              text="Delete action"
              onDelete={this.createDeleteHandler(fields, index)}
            />
          )}
        </Col>
      </Row>
    );
  };

  renderList = ({ fields }) => (
    <div styleName="root">
      <InspectHeader>
        {!this.props.isArchived && (
          <div styleName="header-buttons">
            <InspectButton
              isHeader
              onClick={this.createAddMarkHandler(fields)}
              data-test="create-mark"
            >
              + Mark
            </InspectButton>

            <InspectButton
              isHeader
              onClick={this.createAddUnmarkHandler(fields)}
              data-test="create-unmark"
            >
              + Unmark
            </InspectButton>

            <InspectButton
              isHeader
              onClick={this.createAddShiftHandler(fields)}
              data-test="create-change-span"
            >
              + Change Span
            </InspectButton>

            <InspectButton
              isHeader
              onClick={this.createAddFillHandler(fields)}
              data-test="create-set-feature"
            >
              + Set Feature Value
            </InspectButton>
          </div>
        )}
      </InspectHeader>

      <div styleName="inner" ref={this.props.innerRef}>
        {fields.map((field, index) => this.renderGroup(fields, field, index))}
      </div>
    </div>
  );

  render() {
    return (
      <FieldArray
        name="actions"
        data-test="actions"
        component={this.renderList}
      />
    );
  }
}
